const MINUTES_PER_DAY = 24 * 60;

/**
 * Formats a message response time given in minutes into a compact label.
 *
 * Examples: `null` → `null`, `0.4` → `"<1 min"`, `12` → `"12 min"`,
 * `80` → `"1h 20m"`, `120` → `"2h"`, `20205` → `"14d 1h"`. Rounds to whole
 * minutes before splitting, so `119.6` reads `"2h"` rather than `"1h 60m"`;
 * from a day up, rounds to whole hours instead, so a value never shows minutes
 * next to days.
 *
 * @param minutes response time in minutes, or null/undefined when unknown
 * @returns the formatted label, or null when there is no value to show
 */
export function formatResponseTime(minutes: number | null | undefined): string | null {
  if (minutes === null || minutes === undefined) {return null;}
  if (minutes < 1) {return '<1 min';}
  const total = Math.round(minutes);
  if (total < 60) {return `${total} min`;}
  if (total >= MINUTES_PER_DAY) {
    const totalHours = Math.round(total / 60);
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    return hours === 0 ? `${days}d` : `${days}d ${hours}h`;
  }
  const hours = Math.floor(total / 60);
  const mins = total % 60;
  return mins === 0 ? `${hours}h` : `${hours}h ${mins}m`;
}
